/* file description */

import { ButtonLayout } from '@/asset/AssetTask/templates/Cascade/components';
import { Space } from 'antd';
import React, { useMemo } from 'react';

interface UseMbOptionColumsProps {
  mergeOptionColumns: any;
  setEditPopupVisible: (val: boolean) => void;
  clickRowIndex: React.MutableRefObject<number | undefined>;
  tableBaseMode: 'add' | 'edit' | 'view';
  setOptionState: (val: { visible: boolean; ele: any }) => void;
}


export const useMbOptionColums = ({
  mergeOptionColumns,
  setEditPopupVisible,
  clickRowIndex,
  tableBaseMode,
  setOptionState,
}: UseMbOptionColumsProps) => {
  const isEdit = tableBaseMode === 'add' || tableBaseMode === 'edit';

  const newOptionsColums = useMemo(() => {
    const editOptionColumns = {
      title: '操作',
      dataIndex: 'index',
      fixed: 'right',
      render: (text, record, index) => {
        if (!isEdit && !mergeOptionColumns?.render?.(text, record, index)) return null;
        return (
          <Space
            align="center"
            onClick={(e) => {
              // setOptionState({ visible: false, ele: null });
            }}
          >
            {isEdit &&
              <ButtonLayout
                type="link"
                key="editMobile"
                onClick={() => {
                  clickRowIndex.current = index;
                  setEditPopupVisible(true);
                  setOptionState({ visible: false, ele: null });
                }}
              >编辑
              </ButtonLayout>
            }
            {
              mergeOptionColumns && mergeOptionColumns?.render(text, record, index)
            }
          </Space>
        );
      },
    };
    return editOptionColumns;
  }, [mergeOptionColumns]);


  return {
    mbOptionColums: newOptionsColums,
  };
};
